import {
  CustomersSearchQuery,
  CustomersSearchQueryVariables,
  CustomerStatusCode,
} from "@/gql/graphql";
import { gql, useLazyQuery } from "@apollo/client";
import _ from "lodash";
import { useMemo } from "react";

const customersSearchQuery = gql`
  fragment CustomerSearchNumberAndStatus on Customer {
    id
    custIndex
    custStatus {
      id
      name
      code
    }
    custNo
    name
    parent {
      id
    }
    preselectedHeadAgreement {
      id
    }
  }
  query CustomersSearch($custNoAndStatus: CustomerGetByCustNoAndStatus!) {
    productPrice {
      customers {
        byCustomerNumberAndStatus(custNoAndStatus: $custNoAndStatus) {
          ...CustomerSearchNumberAndStatus
        }
      }
    }
  }
`;

export const UseSearchCustomers = () => {
  const [searchCustomers, { data, loading, error }] = useLazyQuery<
    CustomersSearchQuery,
    CustomersSearchQueryVariables
  >(customersSearchQuery);

  const debouncedSearch = useMemo(
    () =>
      _.debounce(
        (input: string) =>
          searchCustomers({
            variables: {
              custNoAndStatus: {
                allowedStatuses: Object.values(CustomerStatusCode),
                query: input,
              },
            },
          }),
        300
      ),
    [searchCustomers]
  );
  return {
    searchCustomers: debouncedSearch,
    searchedCustomers: data?.productPrice.customers.byCustomerNumberAndStatus,
    loading,
    error,
  };
};
